// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Search_search__JtbP4 {
  width: 100%;
  margin-top: 24px;
  line-height: 0;
  position: relative;
  border-radius: 8px;
}
@media (min-width: 640px) {
  .Search_search__JtbP4 {
    margin-top: 16px;
    border-radius: 12px;
  }
}
@media (min-width: 1200px) {
  .Search_search__JtbP4 {
    margin-top: 0;
  }
}
.Search_search__input__k7uZ1 {
  width: 100%;
  padding-right: 26px;
  padding-left: 16px;
  height: 30px;
  border-radius: 8px;
  background: #EEE;
  font-size: 14px;
  line-height: 30px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.24px;
}
@media (min-width: 640px) {
  .Search_search__input__k7uZ1 {
    height: 64px;
    font-size: 18px;
    letter-spacing: -0.36px;
    border-radius: 12px;
    padding-left: 32px;
  }
}
@media (min-width: 1200px) {
  .Search_search__input__k7uZ1 {
    height: 30px;
    border-radius: 8px;
    font-size: var(--fz-sm);
    line-height: var(--lh-sm);
    letter-spacing: -0.02em;
    padding-left: 16px;
  }
}
.Search_search__input__k7uZ1::placeholder {
  color: #4B5058;
}
.Search_search__searchIcon__Kwjtu {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: #4B5058;
}
@media (min-width: 640px) {
  .Search_search__searchIcon__Kwjtu {
    width: 32px;
    height: 32px;
    right: 16px;
  }
}
@media (min-width: 1200px) {
  .Search_search__searchIcon__Kwjtu {
    width: 16px;
    height: 16px;
    right: 8px;
  }
}
.Search_search__btnClear__UmcJN {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #222222;
}
.Search_search--is-loading__d\\+cm8 {
  width: 100%;
  height: 30px;
}
@media (min-width: 640px) {
  .Search_search--is-loading__d\\+cm8 {
    height: 64px;
  }
}
@media (min-width: 1200px) {
  .Search_search--is-loading__d\\+cm8 {
    height: 30px;
  }
}
.Search_search--with-clear__zu8\\+N .Search_search__input__k7uZ1 {
  padding-left: 28px;
}
.Search_search--with-clear__zu8\\+N .Search_search__searchIcon__Kwjtu {
  right: auto;
  left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/Search/Search.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AACF;AACE;EAPF;IAQI,gBAAA;IACA,mBAAA;EAEF;AACF;AAAE;EAZF;IAaI,aAAA;EAGF;AACF;AADE;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAGJ;AADI;EAbF;IAcI,YAAA;IACA,eAAA;IACA,uBAAA;IACA,mBAAA;IACA,kBAAA;EAIJ;AACF;AAFI;EArBF;IAsBI,YAAA;IACA,kBAAA;IACA,uBAAA;IACA,yBAAA;IACA,uBAAA;IACA,kBAAA;EAKJ;AACF;AAHI;EACE,cAAA;AAKN;AADE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;AAGJ;AADI;EAPF;IAQI,WAAA;IACA,YAAA;IACA,WAAA;EAIJ;AACF;AAFI;EAbF;IAcI,WAAA;IACA,YAAA;IACA,UAAA;EAKJ;AACF;AAFE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;AAIJ;AADE;EACE,WAAA;EACA,YAAA;AAGJ;AADI;EAJF;IAKI,YAAA;EAIJ;AACF;AAFI;EARF;IASI,YAAA;EAKJ;AACF;AAAM;EACE,kBAAA;AAER;AACM;EACE,WAAA;EACA,SAAA;AACR","sourcesContent":[".search {\n  width: 100%;\n  margin-top: 24px;\n  line-height: 0;\n  position: relative;\n  border-radius: 8px;\n\n  @media (min-width: 640px) {\n    margin-top: 16px;\n    border-radius: 12px;\n  }\n\n  @media (min-width: 1200px) {\n    margin-top: 0;\n  }\n\n  &__input {\n    width: 100%;\n    padding-right: 26px;\n    padding-left: 16px;\n    height: 30px;\n    border-radius: 8px;\n    background: #EEE;\n    font-size: 14px;\n    line-height: 30px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: -0.24px;\n\n    @media (min-width: 640px) {\n      height: 64px;\n      font-size: 18px;\n      letter-spacing: -0.36px;\n      border-radius: 12px;\n      padding-left: 32px;\n    }\n\n    @media (min-width: 1200px) {\n      height: 30px;\n      border-radius: 8px;\n      font-size: var(--fz-sm);\n      line-height: var(--lh-sm);\n      letter-spacing: -0.02em;\n      padding-left: 16px;\n    }\n\n    &::placeholder {\n      color: #4B5058;\n    }\n  }\n\n  &__searchIcon {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #4B5058;\n\n    @media (min-width: 640px) {\n      width: 32px;\n      height: 32px;\n      right: 16px;\n    }\n\n    @media (min-width: 1200px) {\n      width: 16px;\n      height: 16px;\n      right: 8px;\n    }\n  }\n\n  &__btnClear {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #222222;\n  }\n\n  &--is-loading {\n    width: 100%;\n    height: 30px;\n\n    @media (min-width: 640px) {\n      height: 64px;\n    }\n\n    @media (min-width: 1200px) {\n      height: 30px;\n    }\n  }\n\n  &--with-clear {\n    .search {\n      &__input {\n        padding-left: 28px;\n      }\n\n      &__searchIcon {\n        right: auto;\n        left: 8px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search": `Search_search__JtbP4`,
	"search__input": `Search_search__input__k7uZ1`,
	"search__searchIcon": `Search_search__searchIcon__Kwjtu`,
	"search__btnClear": `Search_search__btnClear__UmcJN`,
	"search--is-loading": `Search_search--is-loading__d+cm8`,
	"search--with-clear": `Search_search--with-clear__zu8+N`
};
export default ___CSS_LOADER_EXPORT___;
